import React, { useEffect, useState } from "react";
import axios from "axios";
import { useI18n } from "../lib/i18n";
import PropertyCard from "../components/PropertyCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PropertiesPage() {
  const { t, lang } = useI18n();
  const [properties, setProperties] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/properties`)
      .then((r) => setProperties(r.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  const filtered =
    filter === "all" ? properties : properties.filter((p) => p.type === filter);

  const filters = ["all", "luxury", "residential", "commercial", "investment"];

  return (
    <div className="pt-32 pb-24 lg:pb-32 bg-[#F8F9FA] min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <p className="overline mb-5">{t.properties.overline}</p>
          <h1
            data-testid="properties-page-title"
            className="font-serif text-5xl lg:text-6xl xl:text-7xl text-[#0A1428] leading-[1.05] tracking-tight font-medium"
          >
            {t.properties.title}
          </h1>
          <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">
            {t.properties.subtitle}
          </p>
        </div>

        {/* Filters */}
        <div className="mt-12 flex flex-wrap gap-2 border-b border-[#0A1428]/10 pb-2">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              data-testid={`filter-${f}`}
              className={`px-5 py-3 text-xs uppercase tracking-widest font-semibold transition-colors ${
                filter === f
                  ? "text-[#C5A059] border-b-2 border-[#C5A059] -mb-[2px]"
                  : "text-[#4A5568] hover:text-[#0A1428]"
              }`}
            >
              {t.properties.filters[f]}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading
            ? [1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="bg-white h-[480px] animate-pulse" />
              ))
            : filtered.map((p) => <PropertyCard key={p.id} property={p} lang={lang} />)}
        </div>

        {!loading && filtered.length === 0 && (
          <p className="text-center text-[#4A5568] py-20">No properties.</p>
        )}
      </div>
    </div>
  );
}
